export const uniqueWords = [
    "Prestiż", "Rozwaga", "Sława", "Zaufanie", "Pogoda ducha", "Radość", "Zaangażowanie", "Poczucie sprawstwa", "Samorealizacja", "Ryzyko", "Samodzielność", "Perfekcja", "Wrażliwość", "Asertywność", "Spontaniczność", "Cierpliwość", "Twórczość", "Przygoda", "Podziw", "Szlachetność", "Szczodrość", "Rywalizacja", "Godność", "Czułość", "Przyzwoitość", "Duchowość", "Kreatywność", "Zespołowość", "Efektywność", "Szczęście", "Akceptacja", "Doskonałość", "Stabilność finansowa", "Równouprawnienie", "Harmonia", "Decyzyjność", "Szczerość", "Pracowitość", "Wyjątkowość", "Empatia", "Konsekwencja", "Bezpieczeństwo", "Intuicja", "Rzetelność", "Pasja", "Wierność", "Szacunek", "Skromność", "Wiarygodność", "Wolność", "Mądrość", "Troskliwość", "Uważność", "Autonomia", "Przyjaźń", "Delikatność", "Siła", "Sumienność", "Sukces", "Zadowolenie", "Różnorodność", "Ciekawość", "Wyrozumiałość", "Uczciwość", "Opanowanie", "Miłość", "Rodzina", "Otwartość", "Prostota", "Wiara", "Spełnienie", "Entuzjazm", "Honor", "Przedsiębiorczość", "Autentyczność", "Nadzieja", "Prawość", "Czystość", "Dyskrecja", "Cel", "Balans", "Odwaga", "Innowacyjność", "Rozwój", "Stanowczość", "Bogactwo", "Przyjemność", "Pomoc innym", "Docenienie", "Spokój", "Odpowiedzialność", "Komfort", "Duma", "Beztroska", "Zdrowie", "Zaradność", "Sens", "Optymizm", "Bliskie relacje", "Niezależność", "Pokora", "Tolerancja", "Inteligencja", "Władza", "Kompetencja", "Lojalność", "Stabilność", "Prawda", "Współpraca", "Wpływ", "Elastyczność", "Sprawiedliwość"
];

export const goalMappings = {
    "Szukam pierwszej pracy": {
        "completed": "znalazłeś/aś pierwszą pracę",
        "process": "znalezienie pierwszej pracy"
    },
    "Szukam pracy": {
        "completed": "znalazłeś/aś pracę",
        "process": "znalezienie pracy"
    },
    "Myślę o znalezieniu innej/nowej pracy": {
        "completed": "podjąłeś/łaś decyzję o szukaniu innej pracy",
        "process": "decyzja o szukaniu innej pracy"
    },
    "Wracam na rynek pracy": {
        "completed": "jesteś na rynku pracy",
        "process": "powrót na rynek pracy"
    },
    "Przekwalifikowuje się": {
        "completed": "przekwalifikowałeś/aś się",
        "process": "przekwalifikowanie się"
    }
};

export const convertGenderText = (text, gender) => {
    const replacements = [
        { pattern: /na\/y/g, male: 'na', female: 'ny', neutral: 'ne' },       // Example assumption
        { pattern: /eś\/aś/g, male: 'eś', female: 'aś', neutral: 'eś' },
        { pattern: /y\/a/g, male: 'y', female: 'a', neutral: 'e' },
        { pattern: /ł\/a/g, male: 'ł', female: 'ła', neutral: 'ło' },
        { pattern: /wa\/y/g, male: 'wy', female: 'wy', neutral: 'wy' },       // No change for this pattern
        { pattern: /był\/a/g, male: 'był', female: 'była', neutral: 'było' },
        { pattern: /byli\/y/g, male: 'byli', female: 'były', neutral: 'były' },     // Adjust if needed for plural forms
        { pattern: /zajęt(a|y)/g, male: 'zajęty', female: 'zajęta', neutral: 'zajęte' },
        { pattern: /niespokojn(a|y)/g, male: 'niespokojny', female: 'niespokojna', neutral: 'niespokojne' },
        { pattern: /przeoczał\/a/g, male: 'przeoczał', female: 'przeoczała', neutral: 'przeoczało' },
        { pattern: /mógłbyś\/abyś/g, male: 'mógłbyś', female: 'mógłabyś', neutral: 'mogłobyś' }
    ];

    replacements.forEach(rep => {
        if (gender === "On") {
            text = text.replace(rep.pattern, rep.male);
        } else if (gender === "Ona") {
            text = text.replace(rep.pattern, rep.female);
        } else {
            text = text.replace(rep.pattern, rep.neutral);
        }
    });

    return text;
}